var _defs, _rect, _g, _g2, _circle, _circle2, _circle3, _text, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0b1020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a2150"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "snakeBody",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00e676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00b248"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#bg2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeOpacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 50 H600 M0 100 H600 M0 150 H600 M0 200 H600 M0 250 H600 M0 300 H600 M0 350 H600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 0 V400 M100 0 V400 M150 0 V400 M200 0 V400 M250 0 V400 M300 0 V400 M350 0 V400 M400 0 V400 M450 0 V400 M500 0 V400 M550 0 V400"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#snakeBody)",
    stroke: "#003d1a",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 220,
    width: 40,
    height: 40,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 220,
    width: 40,
    height: 40,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 220,
    width: 40,
    height: 40,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 220,
    width: 40,
    height: 40,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 220,
    width: 40,
    height: 40,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 180,
    width: 40,
    height: 40,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 140,
    width: 40,
    height: 40,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 140,
    width: 40,
    height: 40,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 140,
    width: 40,
    height: 40,
    rx: 8
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 155,
    r: 4,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 155,
    r: 2,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 260,
    r: 14,
    fill: "#ff1744",
    stroke: "#fff",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 50,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: 800,
    fill: "#fff"
  }, "SNAKE WORLD")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 380,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#b0bec5"
  }, "Pure HTML \xB7 Live")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnake);
export default __webpack_public_path__ + "static/media/snake.780a3434369bfc9e344b14acb95fc0f1.svg";
export { ForwardRef as ReactComponent };